var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { staticClass: "mb-3", attrs: { cols: "12" } }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("nav.changePassword")))])
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12", md: "6" } },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-right", attrs: { cols: "3" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("insert.settings.oldPassword")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-left", attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: { "form-group--error": _vm.$v.OldPassword.$error }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "password",
                          placeholder: _vm.$t("insert.settings.yourOldPassword")
                        },
                        model: {
                          value: _vm.$v.OldPassword.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.OldPassword,
                              "$model",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "$v.OldPassword.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-right", attrs: { cols: "3" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("insert.settings.newPassword")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-left", attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: { "form-group--error": _vm.$v.NewPassword.$error }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "password",
                          placeholder: _vm.$t("insert.settings.yourNewPassword")
                        },
                        model: {
                          value: _vm.$v.NewPassword.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.NewPassword,
                              "$model",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "$v.NewPassword.$model"
                        }
                      }),
                      _vm._v(" "),
                      !_vm.$v.NewPassword.minLength
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$t("insert.settings.passwordMinMessage")
                                  .replace(
                                    "{0}",
                                    _vm.$v.NewPassword.$params.minLength.min
                                  )
                              )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-right", attrs: { cols: "3" } }, [
                _vm._v(
                  "\n         " +
                    _vm._s(_vm.$t("insert.settings.newPasswordAgain")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-left", attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "form-group--error": _vm.$v.NewPasswordRe.$error
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "password",
                          placeholder: _vm.$t(
                            "insert.settings.yourNewPasswordAgain"
                          )
                        },
                        model: {
                          value: _vm.$v.NewPasswordRe.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.NewPasswordRe,
                              "$model",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "$v.NewPasswordRe.$model"
                        }
                      }),
                      _vm._v(" "),
                      !_vm.$v.NewPasswordRe.sameAsPassword
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("insert.settings.passwordsDoesNotMatch")
                              )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-right", attrs: { cols: "3" } }),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-left", attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: { variant: "success" },
                          on: { click: _vm.changeIt }
                        },
                        [_vm._v(_vm._s(_vm.$t("nav.changePassword")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e7ce31b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e7ce31b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = null
// module chunks = 